import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 15"
}
const _hoisted_2 = {
  key: 0,
  fill: "currentColor",
  d: "M15.01 3.316l-.478-.372a.365.365 0 0 0-.51.063L8.666 9.879a.32.32 0 0 1-.484.033l-.358-.325a.319.319 0 0 0-.484.032l-.378.483a.418.418 0 0 0 .036.541l1.32 1.266c.143.14.361.125.484-.033l6.272-8.048a.366.366 0 0 0-.064-.512zm-4.1 0l-.478-.372a.365.365 0 0 0-.51.063L4.566 9.879a.32.32 0 0 1-.484.033L1.891 7.769a.366.366 0 0 0-.515.006l-.423.433a.364.364 0 0 0 .006.514l3.258 3.185c.143.14.361.125.484-.033l6.272-8.048a.365.365 0 0 0-.063-.51z"
}
const _hoisted_3 = {
  key: 1,
  fill: "currentColor",
  d: "M 10.91 3.316 L 10.432 2.944 C 10.274 2.821 10.046 2.85 9.922 3.007 L 4.566 9.879 C 4.449 10.036 4.219 10.051 4.082 9.912 L 1.891 7.769 C 1.747 7.629 1.517 7.632 1.376 7.775 L 0.953 8.208 C 0.813 8.352 0.816 8.582 0.959 8.722 L 4.217 11.907 C 4.36 12.047 4.578 12.032 4.701 11.874 L 10.973 3.826 C 11.096 3.668 11.067 3.44 10.91 3.316 Z"
}

import {MessageStatusId} from "~/core-ui/vue/chat/CoreUiChatHistoryHelper";


const __default__ = {
    name: "CoreUiChatHistoryMessageStatus"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    statusId: {}
  },
  setup(__props: any) {

let props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    (__props.statusId === 'readed')
      ? (_openBlock(), _createElementBlock("path", _hoisted_2))
      : (__props.statusId === 'delivered')
        ? (_openBlock(), _createElementBlock("path", _hoisted_3))
        : _createCommentVNode("", true)
  ]))
}
}

})